import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-kpi',
  templateUrl: './progress-kpi.component.html',
  styleUrls: ['./progress-kpi.component.scss'],
})
export class ProgressKpiComponent implements OnInit {
  @Input()
  label:number;
  
  @Input()
  icon:string;

  @Input()
  meta:number;

  @Input()
  valor:number;

  avance:number;
  avanceStr:string;
  valorStr:string;
  color:string;
  color2:string;
  constructor() {
    
  }

  ngOnInit() {
    this.setAvance();
  }
  setAvance(){
    if(this.meta >0){
      this.avance=(100*this.valor)/this.meta;
      if(this.avance>0)
        this.avanceStr=this.avance.toFixed(2)
      else
        this.avanceStr="0";
      if(this.valor>0)
        this.valorStr=Math.round(this.valor).toString()
      else
        this.valorStr="0";
      console.log(this.avance);
      console.log(this.avanceStr);
      this.setColor();
    }
  }
  setColor(){
    if(this.avance<=25){
      this.color='#7c0303'; //rojo
      this.color2='#49363f';
      return;
    }
    if(this.avance<=40){
      this.color='#f99f46'; //tomate
      this.color2='#48363f';
      return;
    }
    if(this.avance<=75){
      this.color='#fbce64'; //amarillo
      this.color2='#554e48';
      return;
    }  
    this.color='#7ad67d'; //verde
    this.color2='#294c4f';
  }
}
